<script setup>
import { defineProps } from 'vue'
import { useMainStore } from '@/stores/main'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import ApiEndpointSlideOver from '@/components/Docs/ApiEndpointSlideOver.vue'

const mainStore = useMainStore()

const props = defineProps({
  title: String,        // Endpoint path (e.g., "/query/ip/:ip")
  method: String,       // HTTP method: "GET" or "POST"
  name: String,         // Endpoint name for slideover (e.g., "IP Information")
  query: String,        // Dynamic query URL (computed from parameters)
  body: Object          // Request body (optional, for POST only)
})

function runRequest() {
  mainStore.show_slideover(
    ApiEndpointSlideOver,
    { query: props.query, name: props.name, method: props.method, body: props.body },
    { width: 50 },
    props.name
  )
}
</script>

<template>
  <div class="block mb-3">
    <div class="title">
      <div class="title-content">
        <span v-if="method === 'GET'" class="method" style="color: #13ce66;">{{ method }}</span>
        <span v-if="method === 'POST'" class="method" style="color: rgb(92, 178, 242);">{{ method }}</span>
        <span class="endpoint-title">{{ props.title }}</span>
      </div>
      <button class="play-button" @click="runRequest" title="Run request">
        <font-awesome-icon :icon="['fas', 'play']" />
      </button>
    </div>
    <div v-if="props.body && method === 'POST'" class="content">
      <vue-json-pretty :data="props.body" style="overflow: auto; max-height: 600px;"/>
    </div>
  </div>
</template>

<style scoped>
.block {
  border-radius: 10px;
  background-color: #1e252f;
}

.method {
  font-weight: normal;
  font-size: .8rem;
  margin-right: .5rem;
}

.block .title {
  background-color: #2a3340;
  border-radius: 10px 10px 0 0;
  padding: .3rem .8rem;
  color: white;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title-content {
  display: flex;
  align-items: center;
  flex: 1;
}

.endpoint-title {
  color: white;
}

.play-button {
  background-color: #5094ed;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.35rem 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  margin-left: 1rem;
}

.play-button:hover {
  background-color: #4c82c8;
}

.play-button svg {
  width: 10px;
  height: 10px;
}

.block .content {
  padding: .8rem;
  overflow: auto;
  border-radius: 0 0 10px 10px;
}

/* When there's no body, make the title rounded on bottom too */
.block .title:last-child {
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background-color: #2b3340;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}
</style>
